import React from 'react';
import RolePrivateRoute from 'src/components/PrivateRotes/RolePrivateRoute';
import InterestBalanceListView from './components/InterestBalanceListView';
import { accountingInterestBalanceConfig } from './config';

const AccountingInterestBalanceListPage = () => (
  <InterestBalanceListView config={accountingInterestBalanceConfig} />
);

const AccountingInterestBalanceView = () => {
  return (
    <>
      <RolePrivateRoute
        component={AccountingInterestBalanceListPage}
      />
    </>
  );
};


export default AccountingInterestBalanceView;
